import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Icon from '@components/atoms/Icon'
import { Product, ProductVariant } from '@interfaces/product'
import { addToWishlist, removeFromWishlist } from '@slices/wishlistSlice'
import { RootState } from '@redux/store'

export interface WishListButtonProps {
  product: Product
  selectedVariant: ProductVariant
}

const WishListButton: React.FC<WishListButtonProps> = ({ product, selectedVariant }) => {
  const dispatch = useDispatch()
  const wishlistItems = useSelector((state: RootState) => state.wishlist.items)
  const [isSelected, setIsSelected] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false)
  const [isAccountPage, setIsAccountPage] = useState(false)
  const productId = product?.id?.toString()

  useEffect(() => {
    if (window.location.pathname === '/account') {
      setIsAccountPage(true)
    }
  },[])
  // Check if the product is in the wishlist on component mount and when wishlistItems change
  useEffect(() => {
    if (productId) {
      setIsSelected(wishlistItems.some((item) => item.product.id.toString() === productId))
    }
  }, [wishlistItems, productId])

  const handleClick = () => {
    if (!product || !selectedVariant || !productId) return

    setIsAnimating(true)
    setTimeout(() => {
      setIsSelected(!isSelected)
      setIsAnimating(false)
      if (isSelected) {
        dispatch(removeFromWishlist(productId))
      } else {
        dispatch(addToWishlist({ product, selectedVariant }))
      }
    }, 250)
  }

  if (!product || !selectedVariant) {
    return null
  }

  return (
    <button type="button" onClick={handleClick} aria-label="Wishlist" className={`${!isAccountPage && 'group relative flex items-center'}`}>
      <Icon
        name="heart"
        className={`${!isAccountPage ? 'w-8 h-8' : 'w-5 h-5'} ${isSelected ? 'text-red-1' : 'text-disabled'} ${
          isAnimating ? (isSelected ? 'fade-out' : 'fade-in') : ''
        }`}
      />
      <div className="hidden lg:group-hover:block body-xs whitespace-nowrap absolute right-0 top-9">{!isSelected ? ('Add to wishlist' ) : ('Remove from wishlist')}</div>
    </button>
  )
}

export default WishListButton
